// websocket.js
import Endpoints from '../common/Endpoints.vue'
import { io } from 'socket.io-client'

const socket = io(`${Endpoints.socketDomain}`, {
    transports: ['websocket', 'polling'],
    upgrade: true,
    withCredentials: false,
    timeout: 15000,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: Infinity,
})

socket.on('connect', () => {
})

socket.on('disconnect', () => {
})

socket.on('connect_error', () => {
})

if (socket?.io?.on) {
    socket.io.on('reconnect_attempt', () => {
    })
}

export default socket
